import { render, staticRenderFns } from "./ComposeNoteEditor.vue?vue&type=template&id=d5f9a3fa&scoped=true"
import script from "./ComposeNoteEditor.vue?vue&type=script&lang=js"
export * from "./ComposeNoteEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f9a3fa",
  null
  
)

export default component.exports